<app-last-mile-table
  [dataSource]="dataSource"
  [lastMileState]="LastMileStateEnum.Active"
  [warehouses]="warehouses"
  [businesses]="businesses"
  (tableActionTaken)="handleTableAction($event)"
></app-last-mile-table>
